import { useCallback, useState } from 'react';

/** Shown when the user tries to continue without completing every question on the page. */
export const ALL_QUESTIONS_REQUIRED_MESSAGE =
  'Please answer all questions before continuing to the next page.';

/**
 * Survey pages: require every question answered before proceeding. Use `canProceed(allAnswered)`
 * on primary actions; show `warning` in the UI. Call `dismissWarning` when answers change.
 */
export function useSurveyRequiredAnswers() {
  const [warning, setWarning] = useState<string | null>(null);

  const dismissWarning = useCallback(() => setWarning(null), []);

  /** Returns true if the user may proceed; otherwise sets `warning` and returns false. */
  const canProceed = useCallback((allAnswered: boolean, message?: string) => {
    if (!allAnswered) {
      setWarning(message ?? ALL_QUESTIONS_REQUIRED_MESSAGE);
      return false;
    }
    setWarning(null);
    return true;
  }, []);

  return { warning, canProceed, dismissWarning };
}
